export default __webpack_public_path__ + "static/media/portfolio.66adb107.PNG";